'use client'

import { useDraftModeEnvironment } from 'next-sanity/hooks'

export function DisableDraftMode() {
    const environment = useDraftModeEnvironment()

    // Mostra solo quando non si è già dentro il Presentation Tool
    if (environment === 'live' || environment === 'unknown') return null

    return (
        <a
            href="/api/draft-mode/disable"
            className="fixed bottom-4 left-4 z-50 rounded-full bg-black/80 px-4 py-2 text-sm font-medium text-white shadow-lg backdrop-blur hover:bg-black/90 transition-colors"
        >
            Esci dalla modalità bozza
        </a>
    )
}
